import * as ObjectExtensions from "../../../utils/CoreExtensions/ObjectExtensions";

const pushProp = (mergedProp, incomingProp) => {
  ObjectExtensions.map(incomingProp, ([attr, value]) => {
    if (attr === "className" || attr.endsWith("ClassName")) {
      mergedProp[attr] = [mergedProp[attr], value].filter(Boolean).join(' ').trim();
      // Note: .filter(Boolean) keeps only truthy values in the array before joining them.
    }
    else if (attr === "style") {
      mergedProp.style = { ...mergedProp.style, ...value }
    }
    else if (typeof value === "function") {
      const originalFunction = mergedProp[attr];
      if (originalFunction) {
        mergedProp[attr] = (...args) => {
          originalFunction(...args);
          value(...args);
        };
      } else {
        mergedProp[attr] = value;
      }
    }
    else if (!(attr in mergedProp)) {
      mergedProp[attr] = value;
    }
    else {
      throw new Error(`Didn't know how to merge prop ${attr}. Only 'className' and 'style' are supported for now`);
    }
  });
};

// This method is to merge react props with component specific attributes
// As of now, className and style props are supported
// Rest of the props, if there is a single occurrence, it will be retained. Else, error will be thrown
// className props are concatenated
// style props are shallow merged with later values taking precedence
// Inspired by https://github.com/andrewbranch/merge-props

export const mergeProps = (...props) => {
  let mergedProp = {};
  const refinedProps = props.filter(prop => prop);
  refinedProps.map((prop) => pushProp(mergedProp, prop));
  return mergedProp;
};